import { Box, Container, Grid, Typography } from "@mui/material";
import theme from "../theme/theme";

const Goals = () => {
  return (
    <Container>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        <Grid
          item
          spacing={2}
          xs={12}
          sm={6}
          md={6}
          lg={6}
          sx={{
            padding: "20px",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: "2.5rem",
              fontWeight: 700,
              color: theme.palette.primary.main,
              fontFamily:'Emirates',

              textTransform: "uppercase",
            }}
          >
            Our Goals
          </Typography>

          <Typography
            variant="body1"
            sx={{
              marginTop: "20px",
              fontSize: "1.2rem",
              lineHeight: 1.8,
              color: theme.palette.text.primary,
              fontFamily:'Emirates',

            }}
          >
            <span
              style={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                fontFamily:'Emirates',

              }}
            >
              Streamline Visa Services for Seamless Travel:
            </span>
            <br />
            Simplifying visa applications with fast, efficient, and reliable
            services for smooth and confident travel.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              marginTop: "20px",
              fontSize: "1.2rem",
              lineHeight: 1.8,
              color: theme.palette.text.primary,
              fontFamily:'Emirates',

            }}
          >
            <span
              style={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                fontFamily:'Emirates',

              }}
            >
              Deliver Exceptional Customer Service and Support:
            </span>
            <br />
            Providing expert guidance and timely assistance for a hassle-free
            experience.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              marginTop: "20px",
              fontSize: "1.2rem",
              lineHeight: 1.8,
              color: theme.palette.text.primary,
              fontFamily:'Emirates',

            }}
          >
            <span
              style={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                fontFamily:'Emirates',

              }}
            >
              Expand Global Travel Services Portfolio:
            </span>
            <br />
            Offering customized travel packages, including flights, hotels, and
            personalized itineraries for diverse traveler needs worldwide.
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              backgroundSize: "cover",
              overflow: "hidden",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <img
              src="/goals.webp"
              alt="Background"
              style={{
                width: "350px",
                height: "350px",
                objectFit: "contain",
                margin: "auto",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Goals;
